import { HttpClient, HttpEvent, HttpParams, HttpRequest, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AlertController, ModalController, ToastController } from '@ionic/angular';
import { BehaviorSubject, catchError, map, switchMap,from, Observable,of, firstValueFrom, timeout } from 'rxjs';

import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { ApiV1Service } from './api-v1.service';

@Injectable({
  providedIn: 'root'
})
export class ApiV2Service {
  public global_loading=false;
  private currentUserSubject: BehaviorSubject<any>;
  public currentUser: Observable<any>;
  /** Bumps on logout so in-flight refresh calls cannot restore the session afterward. */
  private sessionGeneration = 0;
  private readonly V1_PROFILES_KEY = 'v1_profiles_by_email';
  private refreshUserPromise: Promise<boolean> | null = null;

  //only if running on locally load from environment else load from the server
//  public portal_url = location.href.includes('8100')? environment.portal_url : '';
  public portal_url= environment.V2_R2apiUrl;
 // public portal_url = environment.portal_url;// location.href.includes('8100')? environment.portal_url : '';
  public matrix_url = this.portal_url;
  
  constructor( private http: HttpClient, public toastController: ToastController ,
    public modalController:ModalController,
    public alertController: AlertController,
    private location: Location, private router: Router,
    private apiV1Service: ApiV1Service) {
    const storedUser = localStorage.getItem('currentUser');
    this.currentUserSubject = new BehaviorSubject<any>(
      storedUser ? JSON.parse(storedUser) : null
    );
    this.currentUser = this.currentUserSubject.asObservable();
   }


    auth(action:any='login',payload:any={},provider:any=''){
    let is_matrix=false;
    let url=this.portal_url+'/auth';
    let method='post';
        switch(action){
          case 'login': 
            url+='/login';
          break;
        }

       // if(method=='post'){
          //send POST request
          return this.http.post<any>(url, payload).pipe(
            switchMap((res) => {
              if (res.data?.access_token) {
                res.data.date_created = new Date();
                //document.cookie = `directus_refresh_token=${res.data.refresh_token}; path=/;`;
                this.storeUserSession(res.data.access_token, res.data.refresh_token, payload.email);
                localStorage.setItem('active_account', payload.email);
              }
        
              // Wait for getSetCurrentUser to complete before returning
              return from(this.getSetCurrentUser(res.data.refresh_token)).pipe(
                map((userData) => {
                  // Combine both login + user info response if needed
                  return {
                    ...res,
                    user: userData,
                  };
                })
              );
            })
          )
        

    }
    
//  async getSetCurrentUser(reftoken=null){
//     try {

        
//       let rt = await this.http.post<any>(this.portal_url+'/auth/refresh', {refresh_token:this.getCookie('directus_refresh_token')},{withCredentials:true}).toPromise();
//      // console.log(rt);
//         if(rt?.data?.access_token){

//          // if(this.getCookie('directus_refresh_token')){
//             document.cookie = `directus_refresh_token=${rt.data.refresh_token}; path=/;`;
//           //}
//       localStorage.setItem('refresh_token',rt.data.refresh_token);
//       let params={access_token:rt.data.access_token,fields:'*,role.*'};
//       let r = await this.http.get<any>(this.portal_url+'/users/me', {
//         params: params
//       ,withCredentials:true}).toPromise();

//         let udata=r.data;
//         console.log(udata);
//         this.storeUserSession(rt.data.access_token, rt.data.refresh_token, udata.email);
//         if(udata){
//           udata.session=rt.data;
//           localStorage.setItem('currentUser', JSON.stringify(udata));
//           this.currentUserSubject.next(udata);
//         }

//       }
//    // }

//     }
//     catch (error:any) {
//        localStorage.removeItem('currentUser');
//        localStorage.clear();
//         console.log(location.href);
//        if(location.href.includes('auth')){
//         console.log('auth page running on dev mode');
        
//        }
//        else if(location.href.includes('8100')){ 
//         // Code is running in the browser dev mode
//         location.href = '/auth';
//       }
//       else if (window.top && window.top !== window.self) {
//         // Code is running inside an iframe
//         //window.top.location.href = '/admin/login?redirect=custom-app';
//         //this.router.navigate(['/auth']);
//         this.router.navigate(['/auth']).then(() => {
//           // reload the page after redirect
//           window.location.reload();
//         });
//       } else {
//         // Code is running in the main window
//         //window.location.href = '/admin/login?redirect=custom-app';
//         //this.router.navigate(['/auth']);
//         this.router.navigate(['/auth']).then(() => {
//           // reload the page after redirect
//           window.location.reload();
//         });
//       }
//        //this.present_toast('error','Error',error.error.message);
//        //location.href = '/admin/login';
     
//     }
    
//   }


async getSetCurrentUser(refreshToken: string | null = null): Promise<boolean> {
  if (this.refreshUserPromise) {
    return this.refreshUserPromise;
  }

  this.refreshUserPromise = this.refreshCurrentUser(refreshToken).finally(() => {
    this.refreshUserPromise = null;
  });

  return this.refreshUserPromise;
}

private async refreshCurrentUser(refreshToken: string | null = null): Promise<boolean> {
  const genAtStart = this.sessionGeneration;
  try {
    // Block silent refresh after forced logout, but allow explicit token from /auth/login (credential login).
    const hasExplicitRefresh =
      refreshToken !== null && refreshToken !== undefined && String(refreshToken).length > 0;
    const reauthRequired =
      localStorage.getItem('reauth_required') || sessionStorage.getItem('reauth_required');
    if (reauthRequired && !hasExplicitRefresh) {
      return false;
    }
    let emailactive= localStorage.getItem('active_account');
    let active_accounts=this.getActiveAccount(emailactive);
    const refresh_token = refreshToken || active_accounts?.refresh_token || localStorage.getItem('refresh_token');
    if (!refresh_token) throw new Error('No refresh token found');
// console.log(refresh_token);
    const rt = await firstValueFrom(
      this.http.post<any>(`${this.portal_url}/auth/refresh`, { refresh_token })
    );
    if (genAtStart !== this.sessionGeneration) {
      return false;
    }
// console.log(rt?.data);
    if (rt?.data?.access_token) {
      // Update all tokens everywhere
      //document.cookie = `directus_refresh_token=${rt.data.refresh_token}; path=/;`;
      localStorage.setItem('refresh_token', rt.data.refresh_token);
// console.log('access_token', rt?.data?.access_token);
      // Get user info
      //const params = { access_token: rt.data.access_token, fields: '*,role.*' };
      const headers = new HttpHeaders({
        Authorization: `Bearer ${rt.data.access_token}`,
        
      });
      const r = await firstValueFrom(
        this.http.get<any>(`${this.portal_url}/users/me?fields=*,role.*`, { headers })
      );

      if (genAtStart !== this.sessionGeneration) {
        return false;
      }

// console.log(r.data);
      const userData = r.data;
      const sessionEmail =
        localStorage.getItem('active_account') || userData.email;
      this.storeUserSession(
        rt.data.access_token,
        rt.data.refresh_token,
        sessionEmail
      );
      localStorage.setItem('refresh_token', rt.data.refresh_token);
console.log(userData);
      // Set active user session
      if (userData) {
        userData.session = rt.data;
        const savedV1 = this.getStoredV1Profile(sessionEmail);
        if (savedV1) {
          userData.v1_data = savedV1;
        }
        // Do NOT copy previous account's v1_data onto a different email/alias.
        localStorage.setItem('currentUser', JSON.stringify(userData));
        this.currentUserSubject.next(userData);
        try {
          localStorage.removeItem('reauth_required');
          sessionStorage.removeItem('reauth_required');
        } catch {
          /* ignore */
        }
        return true;
      }
    }

  } catch (error: any) {
    console.error('Error refreshing user session:', error);
    const status = error?.status;
    if (status === 401 || status === 403 || status === 419) {
      this.sessionGeneration++;
      const sessionEmail = localStorage.getItem('active_account');
      if (sessionEmail) {
        this.removeStoredAccount(sessionEmail);
      }
      localStorage.removeItem('currentUser');
      localStorage.removeItem('refresh_token');
      this.currentUserSubject.next(null);
      const switching = sessionStorage.getItem('account_switch_in_progress');
      if (!switching && !location.href.includes('/auth')) {
        try {
          sessionStorage.setItem('auth_notice', 'Your session has expired. Please login again.');
        } catch {
          /* ignore */
        }
        this.router.navigate(['/auth']);
      }
    }
    return false;
  }
  return false;
}

  storeV1Profile(email: string, profile: any): void {
    if (!email || !profile) {
      return;
    }
    const map = JSON.parse(localStorage.getItem(this.V1_PROFILES_KEY) || '{}');
    map[email] = profile;
    localStorage.setItem(this.V1_PROFILES_KEY, JSON.stringify(map));
  }

  removeV1Profile(email: string): void {
    if (!email) {
      return;
    }
    try {
      const map = JSON.parse(localStorage.getItem(this.V1_PROFILES_KEY) || '{}');
      if (map && map[email]) {
        delete map[email];
        localStorage.setItem(this.V1_PROFILES_KEY, JSON.stringify(map));
      }
    } catch {
      /* ignore */
    }
  }

  getStoredV1Profile(email: string | null | undefined): any {
    if (!email) {
      return null;
    }
    const map = JSON.parse(localStorage.getItem(this.V1_PROFILES_KEY) || '{}');
    return map[email] ?? null;
  }

  /**
   * All V1 profiles that still have an open login session on this device
   * (primary + any switched secondary accounts). Deduped by user_id.
   */
  private collectV1LogoutProfiles(): any[] {
    const out: any[] = [];
    const seen = new Set<string>();
    const add = (profile: any) => {
      if (!profile?.token) {
        return;
      }
      const uid = profile.id != null ? String(profile.id) : '';
      const sid =
        profile.login_session_id != null ? String(profile.login_session_id) : '';
      const key = uid || sid || profile.email || profile.token;
      if (!key || seen.has(key)) {
        return;
      }
      seen.add(key);
      out.push(profile);
    };
    try {
      const map = JSON.parse(localStorage.getItem(this.V1_PROFILES_KEY) || '{}');
      Object.values(map || {}).forEach((profile) => add(profile));
    } catch {
      /* ignore */
    }
    add(this.currentUserValue?.v1_data);
    try {
      const stored = JSON.parse(localStorage.getItem('currentUser') || 'null');
      add(stored?.v1_data);
    } catch {
      /* ignore */
    }
    return out;
  }

  /** Attach V1 profile (permissions, token) after switching alias accounts. */
  mergeV1Profile(v1User: any): void {
    if (!v1User) {
      return;
    }
    const current = this.currentUserValue;
    if (!current) {
      return;
    }
    const email =
      localStorage.getItem('active_account') || v1User.email || current.email;
    const stored = this.getStoredV1Profile(email);
    // Never inherit another alias's v1_data when emails/ids differ
    const sameIdentity =
      !!current.v1_data &&
      ((v1User.email && current.v1_data.email === v1User.email) ||
        (v1User.id != null &&
          current.v1_data.id != null &&
          String(current.v1_data.id) === String(v1User.id)));
    const previous = stored || (sameIdentity ? current.v1_data : null);
    let src = v1User.src ?? previous?.src;
    if (String(src || '').trim().toUpperCase() === 'V2D') {
      src = 'web';
    }
    current.v1_data = {
      ...(previous || {}),
      ...v1User,
      src,
      token: v1User.token || previous?.token,
      login_session_id:
        v1User.login_session_id ?? previous?.login_session_id ?? null,
    };
    if (email) {
      this.storeV1Profile(email, current.v1_data);
    }
    localStorage.setItem('currentUser', JSON.stringify(current));
    this.currentUserSubject.next(current);
  }

  removeStoredAccount(email: string): void {
    if (!email) {
      return;
    }
    const accounts = JSON.parse(localStorage.getItem('accounts') || '[]');
    const next = accounts.filter((acc: any) => acc.email !== email);
    localStorage.setItem('accounts', JSON.stringify(next));
  }

  storeUserSession(access: string, refresh: string, email: string) {
    let accounts = JSON.parse(localStorage.getItem('accounts') || '[]');
    const newAccount = { email:email, access_token: access, refresh_token: refresh };
    
    // Replace if account already exists
    const existingIndex = accounts.findIndex((acc: any) => acc.email === email);
    if (existingIndex !== -1) {
      accounts[existingIndex] = newAccount;
      // console.log('extingaccount')
    } else {
      accounts.push(newAccount);
      // console.log('new_account')
    }
    // console.log(newAccount);

    localStorage.setItem('accounts', JSON.stringify(accounts));
  
    // set active account
    
  }

  getActiveAccount(email) {
    const accounts = JSON.parse(localStorage.getItem('accounts') || '[]');
    const activeEmail = email;
    return accounts.find((acc: any) => acc.email === activeEmail);
  }


  async present_toast(type:any, header:any, msg = '',options:any={}) {
    let color = 'primary';
    //console.log(type);
    switch (type) {
      case 'success':
        color = 'success';
        break;

      case 'info':
        color = 'success';
        break;

      case 'error':
      case 'danger':
        color = 'danger';
        break;

      default:
        color = 'primary';
    }
    const toast = await this.toastController.create({
      header: header,
      message: msg ?? '',
      duration: options.duation ?? 3000,
      color: color,
      cssClass: 'custom-alert',
      position: 'top',
      buttons: [
        {
          text: 'Close',
          role: 'cancel',
          handler: () => {
            //console.log('Cancel clicked');
          },
        },
      ],
    });
    await toast.present();
  }

  public get currentUserValue(): any {
    return this.currentUserSubject.value;
  }

  async presentAlertConfirm(header:any,message:any,ok:any='OK',cancel:any='Cancel', cssClass: string = 'custom-alert'): Promise<boolean> {
    //create alert controller and return yes for true and false for no

     return new Promise<boolean>((resolve) => {
       const alert: any = this.alertController.create({
         header: header,
         message: message,
         cssClass: cssClass,
         backdropDismiss: false,
         buttons: [
          
           {
             text: ok,
             handler: () => {
               resolve(true);
             },
           },
           {
             text: cancel,
             role: 'cancel',
             handler: () => {
               resolve(false);
             },
           },
         ],
       });

      alert.then((alert: { present: () => any }) => alert.present());
     });


 }


 async presentAlertConfirminput(header: any, message: any, ok: any = 'OK', cancel: any = 'Cancel',inputvalue:number=0) {
  return new Promise((resolve) => {
    this.alertController.create({
      header: header,
      message: message,
      cssClass: 'custom-alert',
      backdropDismiss: false,
      inputs: [
        {
          name: 'value',
          type: 'number',
          placeholder: 'Enter discount',
          value:inputvalue
        }
      ],
      buttons: [
        {
          text: cancel,
          role: 'cancel',
          handler: () => {
            resolve(false);
          },
        },
        {
          text: ok,
          handler: (data) => {
            resolve({ value: data.value });
          },
        },
      ],
    }).then(alert => alert.present());
  });
}

 present_alert(heading: string, msg: string = ''): Promise<void> {
  //replace new line with <br>
  msg=msg.replace(/\n/g, '<br>');

  return this.alertController.create({
    header: heading,
    message: msg,
    cssClass: 'custom-alert',
    buttons: ['OK'],
  }).then(alert => alert.present());
}

  getCookie(name:any) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(';').shift();
  }

  close_modal(data:any={}){
    this.modalController.dismiss(data);
  }




  public async get(
    collectionORendpoint: string,
    params: any = {},
    useCache: boolean = false,
    is_public = false,
    is_direct=false,
    is_matrix=false,session:any={}
  ) {
    //if(is_matrix && session.access_token){
    //  params.access_token=session.access_token;
    //}
    //console.log('Requestng Cahe',useCache);

    let endpointPortal =  this.portal_url ;
//    console.log(this.portal_url);
    let urlendpoint = collectionORendpoint;
    if(is_direct){
      //direct url full
      urlendpoint=collectionORendpoint;
    } 
    else if (collectionORendpoint.includes('/')) {
      urlendpoint = endpointPortal + '/' + collectionORendpoint.replace('/','');
    } else {
      urlendpoint = endpointPortal + '/items/' + collectionORendpoint;
      if (!is_public) {
        params.filter = {
          ...params.filter,
         
        };
      }
    }
   
  
//    console.log('urlendpoint', urlendpoint);
    if (params.filter) {
      params.filter = JSON.stringify(params.filter);
    }
    if(params.deep){
      params.deep=JSON.stringify(params.deep);
    }
     
    //if object aggregate then stringify
    if(params.aggregate){
      params.aggregate = JSON.stringify(params.aggregate);
    }

    this.global_loading=true;
    try {
      const data = await this.http.get<any>(urlendpoint, {
        params: this.removeUndefinedParams(params)
      }).toPromise();
  
   
  
       
      this.global_loading=false;
      return data;
    } catch (error) {
      this.global_loading=false;
      // Handle HTTP request errors here
      console.error(error);
      throw error; // Re-throw the error for the caller to handle if needed
    }
  }

  public save<T>(
    collection: string,
    payload: any,
    src='portal',
  ): Observable<T> {
    let isEdit = payload && payload['id']; // Check if it's an edit (has an 'id')
    let isMultiple=false;
    //if its array and has id then its edit
    if (Array.isArray(payload) && payload[0] && payload[0]['id']) {
      isEdit = true;
      isMultiple=true;
    } else if (Array.isArray(payload)) {
      isEdit = false;
      isMultiple=true;
    }

    let endpoint =  this.portal_url;
    //compare payload and item and remove the same properties which are not changed
    //if item is undefined then it is a new item so no need to remove properties
     
    //add tenant
   // payload.app= idata.app.id;
   // console.log('save',payload);
   this.global_loading=true;

   let urlendpoint = collection;
    if (collection.includes('/')) {
     urlendpoint = endpoint + '/' + collection.replace('/','');
   } else {
     urlendpoint = endpoint + '/items/' + collection;
   }

    const save$ = isEdit
      ? this.http.patch<T>(
          `${urlendpoint}/`+(isMultiple ? '' : payload['id']),
          payload
        )
      : this.http.post<T>(`${urlendpoint}`, payload);
      
   this.global_loading=false;
 

    return save$;
  }

  //call api with method, endpoint and params
  call_api(
    method: string,
    endpoint: string,
    params: any = {},
    is_public = false
  ) {
     
    if (params.filter) {
      params.filter = JSON.stringify(params.filter);
    }
    return this.http[method](endpoint, params);
  }

   

  delete(collection: string, itemId: any, params?: any): Observable<void> {
    // Logic for deleting an item from the collection
    // You may want to handle the HTTP DELETE request here

    return this.http.delete<void>( `${this.portal_url}/items/${collection}/${itemId}`).pipe( 
      catchError((err) => {
        console.error(err);
        return of(undefined);
      })
    );

    // Invalidate cache for the collection
   // this.invalidateCache(collection, params);

    return of(undefined); // Return nothing (for demonstration purposes)
  }

  upload(file: File, name = 'file', params: any = {}, src = 'matrix'): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();
    //formData.append('app', this.current_active_app.id);
    formData.append('width', params.width ?? '');
    formData.append('height', params.height ?? '');
    formData.append('file', file,name);

    // Optional extra multipart fields for Directus /files (e.g. description, title, folder, storage)
    const extraFields = params?.fields ?? {};
    if (extraFields && typeof extraFields === 'object') {
      Object.keys(extraFields).forEach((key) => {
        const v = extraFields[key];
        if (v === undefined || v === null) return;
        formData.append(key, String(v));
      });
    }

    let portal_url = src=='portal'?this.portal_url:this.matrix_url;
    const req = new HttpRequest('POST', `${portal_url}/files`, formData, {
      reportProgress: true,
      responseType: 'json'
    });

    return this.http.request(req);
  }

  private removeUndefinedParams(params: any): HttpParams {
    let cleanedParams = new HttpParams();
    for (const key in params) {
      if (params.hasOwnProperty(key) && params[key] !== undefined) {
        cleanedParams = cleanedParams.append(key, params[key]);
      }
    }
    return cleanedParams;
  }

  checkPermission(pid){
    return true;
  }

  cloneWR(p) {
    return p ? JSON.parse(JSON.stringify(p)) : '';
  }
  get_app_url(app:any={}){
     
    return  location.protocol+'//'+location.host;
  }
  
  get_cdn_url(file:any,params:any={},src='portal'){
    let filename_disk =file?.filename_disk ?? '';   
    let id =file?.id ?? file;
   // console.log('filename_disk',filename_disk);
    let   url=this.portal_url+'/assets/'+id+'/'+id+'.jpg';
    

    // if(filename_disk){
    //  // console.log('filename_disk',filename_disk);
    //   url="https://matrix.blr1.cdn.digitaloceanspaces.com/"+filename_disk;
      
    // }
    //else
     if(params?.width || params?.height){
      url+='?'+this.serialize(params);
     } 
     // else if(src=='matrix'){
    //    url="https://matrix.blr1.digitaloceanspaces.com/"+id+".jpg";
    // }
    return url;
  }

  serialize(obj:any) {
    var str :any= [];
    for (var p in obj)
      if (obj.hasOwnProperty(p)) {
        str.push(p + '=' + obj[p]);
      }
    return str.join('&');
  }

  goBack() {
    this.location.back(); // You can also use router.navigateBack if needed
  }

  changePassword(newPassword: string): Observable<any> {

    return this.http.patch(
      `${this.portal_url}/users/me`,
      { password: newPassword }
    );
  }

  changeOtherUserPassword(newPassword: string, id): Observable<any> {
   
    return this.http.patch(
      `${this.portal_url}/users/${id}`,
      { password: newPassword }
    );
  }


  /**
   * Ends the session and redirects.
   * Always closes V1 login session first:
   * - MANUAL   → user clicked Logout (must pass explicitly)
   * - IDLE_3HR → default for idle / any other session close
   * - TOKEN_FAIL → auth refresh failed
   * - ACCOUNT_SWITCH → previous alias closed during switch (prefer dedicated switch path)
   * @param logoutAt optional SQL datetime for IDLE_3HR (last activity + 3h)
   */
  async autologout(
    redirectPath: string = '/auth',
    message: string = '',
    logoutType: string = 'IDLE_3HR',
    logoutAt?: string
  ) {
    const normalizedType = this.apiV1Service.normalizeLogoutType(logoutType);

    // Save logout_at + logout_type for EVERY account on this device
    // (primary + switched secondary) BEFORE clearing local session/tokens
    try {
      const profiles = this.collectV1LogoutProfiles();
      if (profiles.length) {
        await Promise.all(
          profiles.map((profile) =>
            firstValueFrom(
              this.apiV1Service
                .logout(normalizedType, {
                  ...profile,
                  ...(normalizedType === 'IDLE_3HR' && logoutAt
                    ? { logout_at: logoutAt }
                    : {}),
                })
                .pipe(
                  timeout(8000),
                  catchError(() => of(null))
                )
            )
          )
        );
      }
    } catch {
      /* never block logout on session-close failure */
    }

    this.sessionGeneration++;
    this.currentUserSubject.next(null);
    this.clearAuthStorage();
    try {
      if (message) {
        sessionStorage.setItem('auth_notice', message);
      }
      localStorage.setItem('reauth_required', '1');
      sessionStorage.setItem('reauth_required', '1');
    } catch {
      /* ignore */
    }

    let cookies = document.cookie.split('; ');
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i].split('=');
      if (cookie[0] === 'directus_refresh_token') {
        document.cookie = cookie[0] + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      }
    }
    document.cookie = `directus_refresh_token=; path=/;`;
    if (window.parent && window.parent !== window.self) {
      window.parent.location.href = redirectPath;
    } else {
      location.href = redirectPath;
    }
  }

  /** Clear session state without navigation (e.g. auth guard when re-auth is mandatory). */
  invalidateSessionState(): void {
    this.sessionGeneration++;
    this.currentUserSubject.next(null);
    this.clearAuthStorage();
    try {
      localStorage.setItem('reauth_required', '1');
      sessionStorage.setItem('reauth_required', '1');
    } catch {
      /* ignore */
    }
    let cookies = document.cookie.split('; ');
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i].split('=');
      if (cookie[0] === 'directus_refresh_token') {
        document.cookie = cookie[0] + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      }
    }
    document.cookie = `directus_refresh_token=; path=/;`;
  }

  private clearAuthStorage(): void {
    [
      'currentUser',
      'refresh_token',
      'active_account',
      'accounts',
      this.V1_PROFILES_KEY,
      'token',
      'reauth_required',
      'lastActivity',
      'ionic_inactivity_last',
      'ionic_inactivity_stay',
    ].forEach((key) => localStorage.removeItem(key));
  }

  addLegalNotice(data: any) {
    return this.http.post(this.matrix_url+'/items/legal_notice', data);
  }




  postExternal(url: string, payload: any) {
    return this.http.post(url, payload);
  }


}
